/**
 * Shared state classes for form controls in the UI kit.
 *
 * Focus, disabled and error states read the skin state tokens emitted by
 * `customer-skin.ts` (`--focus-ring-width`, `--focus-ring-offset`,
 * `--state-disabled-opacity`) and fall back to the kit's previous defaults
 * when no tenant skin supplies them.
 */
export type ControlSize = 'sm' | 'default' | 'lg';

export const controlFocusClass =
  'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[length:var(--focus-ring-width,3px)] focus-visible:ring-offset-[length:var(--focus-ring-offset,0px)]';

export const controlInvalidClass =
  'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive';

export const controlDisabledClass =
  'disabled:cursor-not-allowed disabled:opacity-[var(--state-disabled-opacity,0.5)]';
